import { growColumn, shrinkColumn } from './resize-logic';
import { updateColgroup } from './resize-state';
export var resizeColumn = function (resizeState, colIndex, amount, tableRef, selectedColumns) {
    var newState = amount > 0
        ? growColumn(resizeState, colIndex, amount, selectedColumns)
        : amount < 0
            ? shrinkColumn(resizeState, colIndex, amount, selectedColumns)
            : resizeState;
    updateColgroup(newState, tableRef);
    return newState;
};
//# sourceMappingURL=resize-column.js.map